import { breadcrumb } from './breadcrumb';
import { auth } from './auth';
import { payment } from './payment';
import { profile } from './profile';
import { document } from './document';
import { register } from './register';
import { reset_password } from './reset-password';
import { dashboard } from './dashboard';
import { errors } from './errors';

export const core = {
  dashboard,
  document,
  breadcrumb,
  auth,
  payment,
  profile,
  register,
  reset_password,
  errors
};